import type { ScheduleDailyTag } from "@/pages/human-resources/time-management/business/schedule/ScheduleDailyTag.ts";
import type { DailyTagResolver } from "@/pages/human-resources/time-management/business/reference/DailyTagResolver.ts";

export interface ScheduleDailyTagOut {
  id?: string;
  dailyTagId: string;
  shiftNumber?: number;
  overriddenMinutes?: number;
}

export function mapToScheduleDailyTag(
  resolver: DailyTagResolver,
  sdto: ScheduleDailyTagOut,
): ScheduleDailyTag {
  return {
    id: sdto.id,
    tag: resolver.getById(sdto.dailyTagId),
    shiftNumber: sdto.shiftNumber,
    overriddenMinutes: sdto.overriddenMinutes,
  };
}
